import React from "react";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
import bgImg from "../assets/backgroundImg.webp";
import { Helmet } from "react-helmet-async";


export function ContactForm() {
    const { t } = useTranslation();

    const handleSubmit = async (e) => {
        e.preventDefault();

        const form = e.target;
        const formData = new FormData(form);

        try {
            const response = await fetch("https://api.web3forms.com/submit", {
                method: "POST",
                body: formData,
            });

            const result = await response.json();
            if (result.success) {
                form.reset();

                Swal.fire({
                    position: "center",
                    icon: "success",
                    title: t("contact.successMessage"),
                    showConfirmButton: false,
                    timer: 3000,
                    customClass: {
                        title: "text-xl font-medium",
                    },
                });

            }
        } catch (error) {

            Swal.fire({
                position: "center",
                icon: "error",
                title: t("contact.errorMessage"),
                showConfirmButton: false,
                timer: 2000,
                customClass: {
                    title: "text-xl font-medium",
                }

            });
        }
    };

    return (
        <div className="contact-form px-4">
            <Helmet>
                <meta name="description" content={t("meta.description")} />
                <meta name="keywords" content={t("meta.keywords")} />
                <meta name="author" content={t("meta.author")} />
            </Helmet>
            <p className="text-3xl text-center font-bold xs:pt-20 sm:pt-20 md:pt-20 lg:pt-20 md:text-4xl lg:text-5xl">{t("contact.heading")}</p>
            <div className="sm:pb-20 md:pb-0 lg:pb-0 px-2 mt-8">
                <div className="flex flex-col md:flex-row gap-8 items-center lg:px-20">
                    {/* Left Side Image */}
                    <div className="flex justify-center w-full md:w-1/2">
                        <img
                            className="w-4/5 sm:w-4/5  lg:w-4/5 rotate-img"
                            src={bgImg}
                            alt="Background"
                        />
                    </div>

                    {/* Form Section */}
                    <form
                        id="form"
                        className="flex flex-col w-full md:w-1/2 gap-y-4"
                        onSubmit={handleSubmit}
                    >
                        <input type="hidden" name="access_key" value="12259d39-6ce8-4900-82d9-2e52bc4d86f1" />

                        {/* Input Fields */}
                        <div className="flex flex-col sm:flex-row gap-4">
                            <input
                                type="text"
                                name="name"
                                placeholder={t("contact.name")}
                                className="p-3 border border-[#5ecaf4] rounded-lg w-full bg-transparent focus:outline-none"
                                required
                            />
                            <input
                                type="email"
                                name="email"
                                placeholder={t("contact.email")}
                                className="p-3 border border-[#5ecaf4] rounded-lg w-full bg-transparent focus:outline-none"
                                required
                            />
                        </div>

                        <input
                            type="text"
                            name="subject"
                            placeholder={t("contact.subject")}
                            className="p-3 border border-[#5ecaf4] rounded-lg w-full bg-transparent focus:outline-none"
                            required
                        />

                        <textarea
                            name="message"
                            cols="30"
                            rows="5"
                            placeholder={t("contact.message")}
                            className="p-3 border border-[#5ecaf4] rounded-lg w-full bg-transparent focus:outline-none"
                            required
                        ></textarea>

                        {/* Submit Button */}
                        <div className="flex justify-center lg:justify-start">
                            <button
                                type="submit"
                                className="bg-primary hover:bg-primary-dark border border-[#5ecaf4] p-2 text-center text-sm font-medium text-white rounded-lg px-8"
                            >
                                {t("contact.submit")}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

    );
}
